import { Navigate, Route } from 'react-router-dom';
import { IRouteBuilderContext } from '../../types';

function OpenDashboardPage() {
    return <Navigate to="/dashboard" />;
}

export default function (context: IRouteBuilderContext) {
    return (
        <>
            <Route key="home-route" path="/" element={<OpenDashboardPage />} />
        </>
    );
}
